import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * VoiceProse — text written *as* a persona, judge or situation: a persona's
 * background or brief, a judge's verdict reasoning, a situation narrative.
 * The one place the interface switches to serif, signalling "someone is
 * speaking". Upright — quotations use `PersonaVoice` (italic) instead.
 */
export function VoiceProse({
  children,
  as: Tag = "p",
  className,
}: {
  children: ReactNode;
  as?: "p" | "span" | "div";
  className?: string;
}) {
  return (
    <Tag
      className={cn(
        "whitespace-pre-wrap font-serif text-md leading-relaxed",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
